// src/features/sales/components/SalesPurchaseDashboard.tsx
import React, { useState, useMemo } from 'react'
import DateRangePicker, { RangeStrings } from '@shared/components/ui/DateRangePicker'
import SalesMetricsDashboard from './SalesMetricsDashboard'

export default function SalesPurchaseDashboard() {
  const [range, setRange] = useState<RangeStrings>()

  /** forward unchanged ISO strings or leave undefined */
  const payload = useMemo(() => range, [range])

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-neutral-100">Sales / Purchase</h1>
        <DateRangePicker value={range} onChange={setRange} placeholder="Select date range" />
      </div>

      {/* metrics */}
      <SalesMetricsDashboard dateRange={payload} />
    </section>
  )
}